// extracted by mini-css-extract-plugin
export default {"main-container":"App_main-container__EPIb1","title":"App_title__YS7Xx"};